export default {
  getReleaseFee (VueApp, param, callback) {
    VueApp.$sdk.get('/admin/' + param.type + '/' + param.id + '/unassign', {
      token: VueApp.$store.state.session.sessionToken
    }, r => {
      callback(r)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/driver-release.js